import styled, { css } from 'styled-components';
import { Breakpoints } from '../../../../../styled/constants';
import {
  HeaderBackButton,
  HeaderCloseButton,
  HeaderLeftAction
} from '../../../../ui/PageHeader/styled';

export const ModalContent = styled.div`
  padding: 15px;

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 10px 0 0;
  }
`;

export const modalHeaderStyles = (
  isInputModal: boolean,
  isLongTitle: boolean
) => css`
  ${HeaderLeftAction} {
    right: 0;
  }

  @media (min-width: ${Breakpoints.tablet}px) {
    ${HeaderCloseButton} {
      padding-right: 0;
      justify-content: flex-end;
      text-align: right;
    }
  }

  ${isInputModal &&
  css`
    padding: 0 40px;

    ${isLongTitle &&
    css`
      padding-top: 8px;
    `}

    ${HeaderCloseButton} {
      padding-top: 15px;
    }
  `};

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 0 10px;

    ${HeaderCloseButton} {
      padding-right: 10px;
      padding-top: 12px;
      justify-content: flex-end;
    }

    ${isInputModal &&
    css`
      padding-left: 25px;
    `}
  }
`;

export const modalStyles = css`
  border-radius: 7px 7px 0 0;
  padding-bottom: env(safe-area-inset-bottom);
  height: max-content;
  align-self: end;

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 10px 50px 30px;
    align-self: center;
    height: max-content;
  }

  @media (min-width: ${Breakpoints.desktop}px) {
    width: 700px;
  }
`;

export const ReportBackButton = styled(HeaderBackButton)`
  left: 6px;
  width: 30px;
  cursor: pointer;
  padding: 0;

  @media (min-width: ${Breakpoints.tablet}px) {
    width: 38px;
    left: -15px;
  }

  &::after {
    border-color: ${({ theme }) => theme.colors.text.primary};
    margin-left: 9px;

    @media (min-width: ${Breakpoints.tablet}px) {
      margin-left: 13px;
    }
  }
`;
